import { useCustomLandingPageStyles } from './custom-landing-page-styles';

// define custom styles for specific components in a specific platform
export const useCustomStyles = () => {
  const customLandingPageStyles = useCustomLandingPageStyles();
  return {
    AdsStudioLandingPageComponent: customLandingPageStyles,
  };
};
